import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditEmployee, EmployeeList, EmployeesOverview } from "../../components/employee";
import { CREATE_EMPLOYEE, VIEW_EMPLOYEE_ANALYTICS } from "../../constants";
import { useHasPermission } from "../../utils";
export const Employees = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasEmployeeCreate = useHasPermission(CREATE_EMPLOYEE);
  const hasViewAnalytics = useHasPermission(VIEW_EMPLOYEE_ANALYTICS);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasEmployeeCreate && {
      buttonText: "Add Employee",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <PageHeader
          // title
          title="Employees"
          subtitle={`${totalCount} Employees`}
          // button
          buttons={buttons}
        />

        {hasViewAnalytics ? (
          <>
            <Box sx={{ position: "relative", height: 40 }}>
              <EmployeesOverview />
            </Box>
            <EmployeeList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </>
        ) : (
          <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
            <EmployeeList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </Box>
        )}
      </PageLayout>

      {/* add employee modal */}
      <AddEditEmployee open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
